import { render, staticRenderFns } from "./OverviewBox.vue?vue&type=template&id=fb348592"
import script from "./OverviewBox.vue?vue&type=script&lang=js"
export * from "./OverviewBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardFeature: require('/srv/app/components/card/CardFeature.vue').default,ButtonLink: require('/srv/app/components/button/Link.vue').default})
